(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/match-info-components/assets/javascripts/product-odds-cell.js') >= 0) return;  svs.modules.push('/components/sportinfo/match-info-components/assets/javascripts/product-odds-cell.js');
"use strict";


const ProductOddsCell = _ref => {
  let {
    columnHeading,
    rowHeading,
    content,
    className
  } = _ref;
  let role;
  if (columnHeading) {
    role = 'columnheader';
  } else if (rowHeading) {
    role = 'rowheader';
  } else {
    role = 'cell';
  }
  return React.createElement("div", {
    className: "product-odds-cell".concat(className ? " ".concat(className) : ''),
    role: role
  }, content);
};
setGlobal('svs.components.sportinfo.matchInfoComponents.ProductOddsCell', ProductOddsCell);

 })(window);